/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	InspectorControls,
} from '@wordpress/block-editor';
import { PanelBody,Notice } from '@wordpress/components';
import { CheckboxControl } from '@woocommerce/blocks-checkout';
import { getSetting } from '@woocommerce/settings';
/**
 * Internal dependencies
 */
import './style.scss';
const { recaptcha_url } = getSetting( 'i13-recaptcha-checkout-block_data', '' );


export const Edit = ( { attributes, setAttributes } ) => {
	const { text } = attributes;
	const blockProps = useBlockProps();
	return (
		<div { ...blockProps }>
			<div id="recaptcha_admin_placeholder" style={{ marginBottom: '10px',marginTop: '10px'}}>
				<div style={{ width: '100%',clear:'both',backgroundColor:'#fff'}}>
						<img src={recaptcha_url} />
				</div>

				<div style={{ width: '100%',clear:'both'}}>
				<Notice
						className="wc-block-components-notices__notice"
						isDismissible={ false }
						status="info"
					>
						{ __(
							'Please note that actual reCaptcha rendering very based on global recaptcha settings. If you have set V3 as settings it will not render anything on frontend as V3 is hidden algorithm based captcha, It will not show anything like I am not Robot or any challenge.',
							'recaptcha-for-woocommerce'
						) }
					</Notice>

				</div>
			</div>
		</div>
	);
};

export const Save = ( { attributes } ) => {
	const { text } = attributes;
	return (
		<div { ...useBlockProps.save() }>
			<RichText.Content value={ text } />
		</div>
	);
};
